import React from 'react';
import { Alert, Button, Stack, Typography } from '@mui/material';

export const ORIGIN_SETUP_URL = '/configuracoes#entrega-preparo';
const MESSAGES = {
  ready: ['Localização da loja pronta', 'Entrada confirmada e aplicada aos sistemas de entrega.'],
  sync_pending: ['Localização em sincronização', 'A entrada foi confirmada. Aguardamos sua aplicação nos sistemas de entrega.'],
  needs_confirmation: ['Confirme a entrada da loja', 'Não encontramos um ponto preciso para este endereço. O administrador pode marcar a entrada no mapa.'],
  incomplete: ['Complete o endereço da loja', 'Informe rua, número, bairro, cidade, UF e CEP para preparar a localização das entregas.'],
  retry_pending: ['Verificação da localização pendente', 'A verificação automática será tentada novamente. O administrador também pode confirmar a entrada no mapa.'],
  checking: ['Verificando a localização da loja', 'Estamos conferindo o endereço e a aplicação nos sistemas de entrega.'],
};

export default function OriginSetupNotice({ state, compact = false, onConfirm, disabled = false, hasDraft = false }) {
  const { setup, error, busy, canManage, reconcile } = state;
  if (compact && ((!setup && !error) || setup?.status === 'ready')) return null;
  const [title, description] = MESSAGES[setup?.status] || ['Preparação da localização', error || 'Consultando a localização da loja…'];
  const severity = setup?.status === 'ready' ? 'success' : (['sync_pending', 'checking'].includes(setup?.status) || (!setup && !error)) ? 'info' : 'warning';
  return <Alert severity={severity} sx={{ '& .MuiAlert-message': { minWidth: 0, width: '100%' } }}>
    <Stack spacing={1}>
      <Typography fontWeight={800}>{title}</Typography>
      <Typography variant="body2">{description}</Typography>
      {error && setup && <Typography variant="body2">{error}</Typography>}
      {compact ? canManage ? <Button component="a" href={ORIGIN_SETUP_URL} target="_blank" rel="noopener noreferrer" size="small" sx={{ alignSelf: 'flex-start' }}>
        Preparar localização da loja (nova aba)
      </Button> : <Typography variant="body2">Peça ao administrador para acessar Configurações &gt; Entrega e Preparo.</Typography> : canManage && <>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {setup?.status !== 'ready' && setup?.canRetry !== false && <Button onClick={reconcile} disabled={disabled || busy || hasDraft}>
            {busy ? 'Verificando...' : 'Verificar automaticamente'}
          </Button>}
          <Button onClick={onConfirm} disabled={disabled || busy}>{setup?.originVerified ? 'Revisar entrada no mapa' : 'Confirmar entrada da loja'}</Button>
        </Stack>
        {hasDraft && <Typography variant="caption">Há alterações no formulário. Confirme o ponto e salve o endereço antes de verificar automaticamente.</Typography>}
      </>}
    </Stack>
  </Alert>;
}
